import { FC } from 'react';
import TripCartCaptainDropdown from 'src/trip-cart/components/TripCartCaptainDropdown';
import TripCartMultiDayDropdown from '../TripCartMultiDayDropdown';
import styles from './TripCartCaptainAndMultiDay.module.scss';

const TripCartCaptainAndMultiday: FC = () => (
  <div className={styles.root}>
    <TripCartMultiDayDropdown />
    <TripCartCaptainDropdown />
  </div>
);

export default TripCartCaptainAndMultiday;
